/**
 * In-memory token store with sessionStorage fallback for Safari/iOS compatibility.
 *
 * Safari/iOS blocks httpOnly cookies due to ITP (Intelligent Tracking Prevention).
 * We store the JWT in memory and use Authorization: Bearer header for all requests.
 *
 * sessionStorage is used as a fallback for page refreshes (cleared when tab closes).
 * This is a single-user app with no user-generated content, so XSS risk is minimal.
 */

const TOKEN_KEY = 'dt_token';

let _token: string | null = null;

export const tokenStore = {
  get: (): string | null => {
    if (_token) return _token;
    // Check sessionStorage as fallback
    if (typeof window !== 'undefined' && window.sessionStorage) {
      return sessionStorage.getItem(TOKEN_KEY);
    }
    return null;
  },

  set: (token: string): void => {
    _token = token;
    // Persist to sessionStorage for page refreshes
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem(TOKEN_KEY, token);
    }
  },

  clear: (): void => {
    _token = null;
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.removeItem(TOKEN_KEY);
    }
  },
};
